<script lang="ts">

  import {page} from "$app/stores";
  import {onMount} from "svelte";
  import {userService} from "$lib/services/user.service";
  import {toasts} from "$lib/stores/toastStores";
  import {goto} from "$app/navigation";
  import {locale, translate} from "$lib/i18n";
  import {closeDialog} from "$lib/stores/dialogStores";
  import PasswordIcon from "$lib/icons/PasswordIcon.svelte";
  import EyeOffIcon from "$lib/icons/EyeOffIcon.svelte";
  import EyeIcon from "$lib/icons/EyeIcon.svelte";
  import * as yup from "yup";
  import {createForm} from "felte";
  import Button from "$lib/elements/Button.svelte";
  import ForgotPassword from "$lib/icons/ForgotPassword.svelte";

  let code = $page.url.searchParams.get('code');
  let apiErrors: any[] = [];
  let loading = false;
  let passwordVisible = $state(false);
  let passwordVisible2 = $state(false);
  let passwordInput: HTMLInputElement = $state();
  let passwordInput2: HTMLInputElement = $state();
  let data = $state({
      verificationCode: code,
      password: '',
      passwordConfirmation: ''
  })

  onMount(() => {
      confirmCode();
  })

  const schema = yup.object({
      password: yup.string().required(),
      passwordConfirmation: yup.string().required().oneOf([yup.ref('password'), ''], 'Passwords must match'),
  });

  const {form, errors, createSubmitHandler} = createForm({
      validate: async (values) => {
          try {
              await schema.validate(values, { abortEarly: false });
          } catch(err: any) {
              return err.inner.reduce((res: any, value: any) => ({
                  [value.path]: value.message,
                  ...res,
              }), {});
          }
      },
  })

  const altOnSubmit = createSubmitHandler({
      onSubmit: (values) => resetPassword(),
  });

  function confirmCode() {
      userService.confirmVerificationCode(code).then(res => {
          if (res.status === 422) {
              toasts.send('Verification code invalid or expired')
              goto(`/${$locale}`)
              closeDialog('ResetPasswordModal');
              return;
          }
      })
  }

  function resetPassword() {
    userService.resetPassword(data).then(res => {
        console.log(res);
        if (res.status === 422) {
            toasts.send(res.data.message)
            return;
        }
        toasts.send('Password reset successfully')
        closeDialog('ResetPasswordModal');
        goto(`/${$locale}`)
    })
  }

  function handlePasswordVisibility() {
      passwordVisible = !passwordVisible;
      passwordInput.type = passwordVisible ? 'text' : 'password';
  }

  function handlePasswordVisibility2() {
      passwordVisible2 = !passwordVisible2;
      passwordInput2.type = passwordVisible2 ? 'text' : 'password';
  }
</script>


<div class="flex flex-col gap-5 text-white">
  <h2 class="text-center px-2 font-medium text-white border-b border-b-primary-lightBlue pb-3">{$translate('Forgot your password?')}</h2>
  <form use:form class="flex flex-col gap-4">
    <div class="flex flex-col items-center text-sm text-primary-lightBlue gap-4">
      <div class="bg-primary-lightBlue/40 p-3 rounded-full">
        <ForgotPassword/>
      </div>
      <p>{$translate('Enter your new password')}</p>
    </div>
    <div class="rounded-full bg-primary-dark w-full py-2.5 px-6 flex items-center">
      <PasswordIcon/>
      <input class="outline-0 w-full bg-transparent text-sm placeholder-primary-lightBlue ml-2" type="password"
             bind:this={passwordInput} id="password" placeholder="Password" name="password" bind:value={data.password} >
      <button type="button" class="focus:outline-none" onclick={() => handlePasswordVisibility()}>
        {#if passwordVisible}
          <EyeIcon/>
        {:else}
          <EyeOffIcon/>
        {/if}
      </button>
    </div>
    {#if $errors.password}
      <span class="text-red-500 text-xs ml-5 animate-fadeIn">{$errors.password}</span>
    {/if}

    <div class="rounded-full bg-primary-dark w-full py-2.5 px-6 flex items-center">
      <PasswordIcon/>
      <input class="outline-0 w-full bg-transparent text-sm placeholder-primary-lightBlue ml-2" type="password"
             bind:this={passwordInput2} id="confirmPassword" name="passwordConfirmation" placeholder="Confirm Password" bind:value={data.passwordConfirmation
      } >
      <button type="button" class="focus:outline-none" onclick={() => handlePasswordVisibility2()}>
        {#if passwordVisible2}
          <EyeIcon/>
        {:else}
          <EyeOffIcon/>
        {/if}
      </button>
    </div>
    {#if $errors.passwordConfirmation}
      <span class="text-red-500 text-xs ml-5 animate-fadeIn">{$errors.passwordConfirmation}</span>
    {/if}
    <Button loading={loading} on:click={() => altOnSubmit()}>{$translate('Reset Password')}</Button>
  </form>
</div>